import { type QueryHookOptions, useQuery } from "@apollo/client";
import { PaymentsListQuery } from "../graphql/queries";
import type {
  PaymentsListQueryType,
  PaymentsListQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const usePaymentsQuery = (
  options?: QueryHookOptions<
    PaymentsListQueryType,
    PaymentsListQueryVariablesType
  >
) => {
  return useQuery<PaymentsListQueryType, PaymentsListQueryVariablesType>(
    PaymentsListQuery,
    options
  );
};
